/**
 * GRILLHOUSE STORE SWITCHER - TEBIKO (CORREGIDO)
 * Versión con corrección de bucle para Envíos Nacionales
 */

// =================================================================
// 1. CONFIGURACIÓN: CAMBIA ESTE ID EN CADA TIENDA
// =================================================================

// Opciones: 'mty', 'cdmx', 'gdl', 'qro', 'sal', 'chi', 'mtp', 'pvr', 'nac'
var currentStoreId = 'mty'; 

// =================================================================
// 2. BASE DE DATOS DE SUCURSALES
// =================================================================

var storeList = [
  {
    id: 'mty',
    name: 'Monterrey',
    url: 'https://grillhouse.mx',
    imgWeb: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/monterreyhq.png?v=1626654650',
    imgMob: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/monterrey_mob.png?v=1626655993'
  },
  {
    id: 'cdmx',
    name: 'Ciudad de Mexico',
    url: 'https://www.cdmx.grillhouse.mx',
    imgWeb: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/cdmxhq.png?v=1626654650',
    imgMob: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/cdmx_mob.png?v=1626655993'
  },
  {
    id: 'gdl',
    name: 'Guadalajara',
    url: 'https://gdl.grillhouse.mx',
    imgWeb: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/guadalajarahq.png?v=1626654650',
    imgMob: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/guadalajara_mob.png?v=1626655993'
  },
  {
    id: 'qro',
    name: 'Querétaro',
    url: 'https://www.qro.grillhouse.mx',
    imgWeb: 'https://cdn.shopify.com/s/files/1/0582/8401/5785/files/GH_Queretaro_Web.png?v=1634652698',
    imgMob: 'https://cdn.shopify.com/s/files/1/0582/8401/5785/files/GH_Queretaro_Movil.png?v=1634652698'
  },
  {
    id: 'sal',
    name: 'Saltillo',
    url: 'https://www.saltillo.grillhouse.mx', 
    imgWeb: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/saltillohq.png?v=1626654650',
    imgMob: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/saltillo_mob.png?v=1626655993'
  },
  {
    id: 'chi',
    name: 'Chihuahua',
    url: 'https://chihuahua.grillhouse.mx',
    imgWeb: 'https://cdn.shopify.com/s/files/1/0609/3019/5700/files/GH_Botones_Ciudades_Web-_1.png?v=1646155852',
    imgMob: 'https://cdn.shopify.com/s/files/1/0609/3019/5700/files/GH_Botones_Ciudades_Movil-_1.png?v=1646155853'
  },
  {
    id: 'mtp',
    name: 'Metepec',
    url: 'https://metepec.grillhouse.mx',
    imgWeb: 'https://cdn.shopify.com/s/files/1/0610/6175/9199/files/GH_Botones_Metepec_Web.png?v=1648474822',
    imgMob: 'https://cdn.shopify.com/s/files/1/0610/6175/9199/files/GH_Botones_Metepec_Movil.png?v=1648474822'
  },
  {
    id: 'pvr',
    name: 'Puerto Vallarta',
    url: 'https://pvr.grillhouse.mx',
    imgWeb: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/GH_Vallarta_Boton.png?v=1765482120',
    imgMob: 'https://cdn.shopify.com/s/files/1/0266/6368/2128/files/pvr-movil.png?v=1767033679'
  }
];
//BACKUP JSON NACIONAL
/*,
  {
    id: 'nac',
    name: 'Envíos Nacionales',
    url: 'https://www.cdmx.grillhouse.mx', // Comparte URL con CDMX
    imgWeb: 'https://cdn.shopify.com/s/files/1/0482/4544/0674/files/GH_Boton_Nacioneles_Web.png?v=1633143612',
    imgMob: 'https://cdn.shopify.com/s/files/1/0482/4544/0674/files/GH_Boton_Nacionales_Movil.png?v=1633143612'
  }
*/
// =================================================================
// 3. LÓGICA DEL SISTEMA
// =================================================================

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + ";domain=grillhouse.mx; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name + '=;domain=grillhouse.mx; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

document.addEventListener('DOMContentLoaded', function() {

    var isDesktop = screen.width > 641;
    var modalImagesHTML = '';

    storeList.forEach(function(store) {
        var imgSrc = isDesktop ? store.imgWeb : store.imgMob;
        modalImagesHTML += '<input type="image" src="' + imgSrc + '" id="btn_modal_' + store.id + '" class="city-button store-trigger" data-store="' + store.id + '">';
    });

    var popup = '<div class="stores-modal">' +
        ' <div class="stores-modal-content">' +
        '<h1>Elige tu tienda</h1>' +
        modalImagesHTML +
        '</div></div>';

    var cont = document.getElementById('shopify-section-announcement-bar');
    if(cont) cont.innerHTML += popup;

    var modal = document.querySelector(".stores-modal");

    function toggleModal() {
        if(modal) modal.classList.toggle("stores-show-modal");
    }

    // --- FUNCIÓN DE CAMBIO DE TIENDA CON CORRECCIÓN NACIONAL ---
    function setStore(targetId) {
        console.log('Intentando cambiar a: ' + targetId);
        var targetStore = storeList.find(function(s) { return s.id === targetId; });
        if (!targetStore) return;

        // Caso especial: Si eligen NACIONAL y ya estamos en CDMX
        if (targetId === 'nac' && currentStoreId === 'cdmx') {
            eraseCookie('store');
            setCookie('store', 'nac', 365);
            if(modal && modal.classList.contains("stores-show-modal")) toggleModal();
            return;
        }

        // Si ya estamos en la tienda destino
        if (targetId === currentStoreId) {
             if(modal && modal.classList.contains("stores-show-modal")) toggleModal();
             return;
        }

        eraseCookie('store');
        setCookie('store', targetId, 365);
        window.location.replace(targetStore.url + "/?&str=" + targetId);
    }

    // --- RENDERIZADO DEL DROPDOWN ---
    var currentStoreData = storeList.find(function(s) { return s.id === currentStoreId; });
    
    // Si la cookie dice 'nac' y estamos en 'cdmx', mostramos "Envíos Nacionales" en el texto
    var displayCookie = getCookie('store');
    var displayName = currentStoreData ? currentStoreData.name : 'Selecciona Tienda';
    if(displayCookie === 'nac' && currentStoreId === 'cdmx') displayName = 'Envíos Nacionales';

    var listItemsHTML = '';
    storeList.forEach(function(store) {
        if (store.id !== currentStoreId) {
             listItemsHTML += '<li>' +
                '<a href="#" class="store-trigger" data-store="' + store.id + '"><i class="marker" style="margin-right:3px;"></i> ' + store.name + '</a>' +
                '</li>';
        }
        // Si estamos en CDMX, agregar opción de Nacional al dropdown explícitamente si no es la activa
        if(currentStoreId === 'cdmx' && store.id === 'nac' && displayCookie !== 'nac') {
             // Ya se agrega por el loop general, no requiere lógica extra aquí
        }
    });

    var dropdown = '<label class="dd-dropdown">' +
        '<div class="dd-button"><i class="marker"></i> ' + displayName +
        '<svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">' +
        '<path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>' +
        '</svg>' +
        '</div>' +
        '<input type="checkbox" class="dd-input" id="test">' +
        '<ul class="dd-menu">' +
        ' <li class="divider"></li>' +
        listItemsHTML +
        '</ul>' +
        '</label>';

    var header_nav = document.getElementById('announcement-bar__inner');
    if(header_nav) header_nav.innerHTML += dropdown;

    // --- MANEJO DE COOKIES Y REDIRECCIÓN INICIAL ---
    var pass_cook = location.search.split('str=')[1];
    var redirected = false;
    
    if (pass_cook !== undefined && (pass_cook === currentStoreId || (pass_cook === 'nac' && currentStoreId === 'cdmx'))) {
        redirected = true;
        eraseCookie('store');
        setCookie('store', pass_cook, 365);
    }

    var cook = getCookie('store');
    if (cook) {
        // Corrección: No redirigir si la cookie es NAC y estamos en CDMX
        var isNacInCdmx = (cook === 'nac' && currentStoreId === 'cdmx');
        if (cook !== currentStoreId && !isNacInCdmx) {
            setStore(cook);
        }
    } else {
        if (!redirected) toggleModal();
    }

    // --- EVENTOS CLICK ---
    document.addEventListener('click', function(e) {
        var target = e.target.closest('.store-trigger'); 
        if (target) {
            e.preventDefault();
            var storeId = target.getAttribute('data-store');
            setStore(storeId);
        }
        
        // Cerrar dropdown
        const flyoutElement = document.getElementsByClassName('dd-dropdown')[0];
        if(flyoutElement && !flyoutElement.contains(e.target)){
            var checkbox = document.getElementById("test");
            if(checkbox) checkbox.checked = false;
        }
    });

}, false);